import Message from './message';
import EmailVerificationService from './email-verification-service';

export { Message, EmailVerificationService };
export default Message;
